export const coatingLabels = {
    "high_gloss_coating": "High Gloss",
    "matte_touch_coating": "Matte Touch",
    "soft_touch_coating": "Soft Touch",
    "none": "None",
};
